import { useState, useEffect, useCallback } from 'react';
import ReportsService from '@/services/reportsService';

const PERIOD_MAP = {
  today: 'today',
  yesterday: 'yesterday',
  thisWeek: 'this_week',
  thisMonth: 'this_month',
  lastMonth: 'last_month',
};

const formatDate = (d) =>
  d instanceof Date ? d.toISOString().split('T')[0] : d;

export default function useTableUtilization() {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [branchSummary, setBranchSummary] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    period: 'thisMonth',
    startDate: undefined,
    endDate: undefined,
    sectionId: undefined,
    offset: 0,
    limit: 25,
  });

  const fetchTableUtilization = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const params = {
        offset: filters.offset,
        limit: filters.limit,
      };

      if (filters.branchId) params.branchId = filters.branchId;

      if (filters.sectionId) {
        params.sectionId = filters.sectionId;
      }

      if (filters.startDate && filters.endDate) {
        params.startDate = formatDate(filters.startDate);
        params.endDate = formatDate(filters.endDate);
      } else {
        params.period = PERIOD_MAP[filters.period] ?? filters.period;
      }

      const res = await ReportsService.getTableUtilization(params);

      setData(res?.data ?? []);
      setSummary(res?.summary ?? null);
      setBranchSummary(res?.branchSummary ?? []);
      setTotalItems(res?.total ?? 0);

    } catch (err) {
      console.error('useTableUtilization ERROR:', err);
      setError('Failed to load table utilization data');
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchTableUtilization();
  }, [fetchTableUtilization]);

  return {
    data,
    summary,
    branchSummary,
    totalItems,
    loading,
    error,
    setFilters,               
    refresh: fetchTableUtilization,
  };
}
